import React, { useRef, useState, useEffect } from 'react';
import styles from './VideoArea.module.scss';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_TIMELINE_STORE } from 'store';
import SpriteFrame from 'components/editor/SpriteFrame';
import InteractiveAreaCanvas from './InteractiveAreaCanvas';
import { VideoAreaProps } from './types';

const VideoArea = (props: VideoAreaProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      currentMonitorThumbnail,
      incrementCurrentMonitorThumbnailIndex,
      decrementCurrentMonitorThumbnailIndex
    }
  } = props;

  const handleWheel = ({ deltaY }) => {
    deltaY < 0
      ? incrementCurrentMonitorThumbnailIndex()
      : decrementCurrentMonitorThumbnailIndex();
  };
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(100);

  const updateHeight = () => {
    if (containerRef.current) {
      setContainerHeight(containerRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div
      className={styles.container}
      ref={containerRef}
      onWheel={handleWheel}
    >
      {currentMonitorThumbnail &&
        <div className={styles.videoContainer}>
          <SpriteFrame
            size='l'
            frameNumber={currentMonitorThumbnail.frame}
            style={{
              height: containerHeight,
              width: containerHeight * 16 / 9
            }}
          />
        <InteractiveAreaCanvas
          containerHeight={containerRef.current ? containerRef.current.clientHeight : 1}
          containerWidth={containerRef.current ? containerRef.current.clientWidth : 1}
        />
        </div>
      }
    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE)(observer(VideoArea));
